import { attachments } from 'data/project-management/todoListData';
import { Col, Modal, ProgressBar, Row, Toast } from 'react-bootstrap';
import Button from 'components/base/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Project } from 'data/projects';
//import AvatarDropdown from 'components/common/AvatarDropdown';
import Badge from 'components/base/Badge';
//import DatePicker from 'components/base/DatePicker';
//import TodoListItem from '../todo-list/TodoListItem';
import classNames from 'classnames';
import FileListItem from '../todo-list/FileListItem';
import CoverImage from './CoverImage';
import ActionSection from './ActionSection';
import useProjectProgress from '../useProjectProgress';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
// import projectService from 'services/project';
//import { br } from '@fullcalendar/core/internal-common';
import { useEffect, useState } from 'react';
import interceptor from 'services/interceptor';
import { PitchDeck } from 'data/pitchdecks';
import pitchDeckStatusService from 'services/pitchdeckstatus';
import pitchDeckService from 'services/pitchdeck';
import projectsService from 'services/project';
import { useNavigate } from 'react-router-dom';
//import TodoListItem from '../todo-list/TodoListItem';
//import { formatDate } from 'date-fns';

interface BoardViewModalModalProps {
  handleClose: () => void;
  project: Project;
  show: boolean;
}

const BoardViewModal = ({
  handleClose,
  show,
  project
}: BoardViewModalModalProps) => {
  const navigate = useNavigate();
  // const userContext = useContext(UserContext);
  const { progress, bgClassName, variant } = useProjectProgress(project);
  const [localProject] = useState(project);
  const [showEditToast, setShowEditToast] = useState(false);
  const [pitchDecks, setPitchDecks] = useState([]);
  const [toastText] = useState('');

  useEffect(() => {
    const projectId = project.projectId;
    interceptor.apiWithAuth
      .get(`/pitchdeck/get-pitchdecks-by-project-id/${projectId}`)
      .then(response => {
        setPitchDecks(response.data);
      })
      .catch(error => {
        console.error(error);
      });
  }, []);

  // const handleUpdateProjectOutline = async (lbriefOutline: string) => {
  //   if (lbriefOutline === undefined || lbriefOutline === '') return;
  //   project.briefOutline = lbriefOutline;
  //   project.modifiedBy =
  //     userContext && userContext.user ? userContext.user.userId : '';
  //   project.modifiedDate = new Date();

  //   projectService.editProject(project).then(data => {
  //     if (data) {
  //       setToastText('Project outline changed successfully');
  //       setShowEditToast(true);
  //     } else {
  //       console.error('Error:', 'problem editing project ' + project.title);
  //     }
  //   });
  // };

  // const handleStartDateChange = async (newStartDate: string | undefined) => {
  //   if (newStartDate === undefined) return;

  //   const date = new Date(newStartDate);

  //   // Get the UTC date components
  //   const utcYear = date.getUTCFullYear();
  //   const utcMonth = date.getUTCMonth();
  //   const utcDay = date.getUTCDate();

  //   // Create a new Date object using the UTC components
  //   const gmtDate = new Date(utcYear, utcMonth, utcDay);

  //   project.startDate = gmtDate.toISOString();
  //   project.modifiedBy =
  //     userContext && userContext.user ? userContext.user.userId : '';
  //   project.modifiedDate = new Date();

  //   projectService.editProject(project).then(data => {
  //     if (data) {
  //       setToastText('Project start date changed successfully');
  //       setShowEditToast(true);
  //       setLocalProject(data);
  //     } else {
  //       console.error('Error:', 'problem editing project ' + project.title);
  //     }
  //   });
  // };

  // const handleDeadlineDateChange = async (
  //   newDeadlineDate: string | undefined
  // ) => {
  //   if (newDeadlineDate === undefined) return;

  //   const date = new Date(newDeadlineDate);

  //   // Get the UTC date components
  //   const utcYear = date.getUTCFullYear();
  //   const utcMonth = date.getUTCMonth();
  //   const utcDay = date.getUTCDate();

  //   // Create a new Date object using the UTC components
  //   const gmtDate = new Date(utcYear, utcMonth, utcDay);

  //   project.deadline = gmtDate.toISOString();
  //   project.modifiedBy =
  //     userContext && userContext.user ? userContext.user.userId : '';
  //   project.modifiedDate = new Date();

  //   projectService.editProject(project).then(data => {
  //     if (data) {
  //       setToastText('Project deadline changed successfully');
  //       setShowEditToast(true);
  //       setLocalProject(data);
  //     } else {
  //       console.error('Error:', 'problem editing project ' + project.title);
  //     }
  //   });
  // };

  const handleCreateButtonClick = async () => {
    const generateGuid = (): string => {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
        /[xy]/g,
        function (c) {
          const r = (Math.random() * 16) | 0,
            v = c === 'x' ? r : (r & 0x3) | 0x8;
          return v.toString(16);
        }
      );
    };

    const draftStatus =
      await pitchDeckStatusService.getPitchDeckStatusByName('Draft');

    const pitchDeck: PitchDeck = {
      pitchDeckId: generateGuid(),
      projectId: project.projectId,
      generatedByAI: false,
      title: 'PitchDeck' + pitchDecks.length + 1 + ' for ' + project.title,
      type: 'film',
      contentOuterHtml: '',
      publishedURN: '',
      trackingEnabled: true,
      thumbnail:
        'https://nupitchstorage.blob.core.windows.net/nupitch-test-blob-container/nupitch_f7533443-7bcc-419d-abc4-3b17a1169a92_' +
        pitchDecks.length +
        '_bg_img.jpg',
      isTemplate: false,
      statusId: draftStatus.statusId,
      status: draftStatus,
      createdBy: localStorage.getItem('userId') || '',
      createdDate: new Date()
    };

    pitchDeckService.addPitchDeck(pitchDeck).then(data1 => {
      if (data1) {
        console.log('pitchdeck ID:', data1);
        project.pitchDecks = [data1];
      } else {
        console.error('Error:', 'problem with returned pitchdeck ID');
      }
    });
    //add the pitchdeck to the project too
    if (!project.pitchDecks) {
      //create a new array with the new pitchdeck
      project.pitchDecks = new Array<PitchDeck>();
      project.pitchDecks.push(pitchDeck);
    } else {
      project.pitchDecks.push(pitchDeck);
    }
    projectsService.editProject(project).then(data => {
      if (data) {
        navigate(
          `/pages/slide-editor/${data.projectId}/${pitchDeck.pitchDeckId}`
        );
      } else {
        console.error('Error:', 'problem with returned project ID');
      }
    });
  };

  return (
    <>
      <Toast
        show={showEditToast}
        onClose={() => setShowEditToast(false)}
        className="align-items-center bg-dark border-0 bottom-0 end-0 light mb-3 me-3 position-fixed text-white z-index-5"
        delay={3000}
        autohide
      >
        <div className="d-flex">
          <Toast.Body className="P-3">
            <span className="fw-black">
              <code className="text-500">{toastText}</code>
            </span>
          </Toast.Body>
        </div>
      </Toast>
      <Modal
        show={show}
        onHide={handleClose}
        size="xl"
        contentClassName="overflow-hidden"
      >
        <Modal.Header className="position-relative p-0">
          <CoverImage project={project} handleClose={handleClose} />
        </Modal.Header>
        <Modal.Body className="p-0">
          <ActionSection project={localProject} />
          <Row className="g-0">
            <Col xs={12} xl={5} className="border-end border-300 bg-100">
              <div className="px-5 px-lg-6 py-4 bg-white">
                <h3 className="fw-bolder lh-sm mb-5">{localProject.title} </h3>
                <div className="d-flex align-items-center mb-5">
                  <p className="text-1000 fw-700 mb-0 me-2">{progress}%</p>
                  <ProgressBar
                    now={progress}
                    className={classNames('flex-1', bgClassName)}
                    variant={variant}
                  />
                </div>
                <div className="mb-5">
                  <h6 className="text-800 mb-2">Tags</h6>
                  <div className="d-flex gap-2 align-items-center">
                    <Badge variant="phoenix" bg="info" className="fs-10">
                      Quirky
                    </Badge>
                    <Badge variant="phoenix" bg="warning" className="fs-10">
                      Offbeat
                    </Badge>
                    <Badge variant="phoenix" bg="success" className="fs-10">
                      Whacky
                    </Badge>
                    <Button
                      variant="link"
                      className="p-0 fs-9 text-900 fw-bolder text-decoration-none lh-1"
                      startIcon={<FontAwesomeIcon icon={faPlus} />}
                    >
                      Add tag
                    </Button>
                  </div>
                </div>
                {/* <EditableProjectOutlineField
                  className="mb-6"
                  onSave={handleUpdateProjectOutline}
                >
                  {project?.briefOutline || 'No outline'}
                </EditableProjectOutlineField> */}
              </div>
            </Col>

            <Col xs={12} xl={7}>
              <div className="px-5 d-flex justify-content-center">
                {(!pitchDecks || pitchDecks?.length == 0) && (
                  <Button
                    variant="link"
                    className="text-decoration-none p-2 btn btn-soft-info"
                    onClick={() => handleCreateButtonClick()}
                  >
                    Create Deck
                  </Button>
                )}

                {pitchDecks?.length > 0 && (
                  <Button
                    variant="link"
                    className="text-decoration-none p-2 btn btn-soft-info w-100"
                    onClick={() =>
                      navigate(
                        `/pages/slide-editor/${project.projectId}/${
                          (pitchDecks[0] as PitchDeck).pitchDeckId
                        }`
                      )
                    }
                  >
                    Edit Deck
                  </Button>
                )}
              </div>
            </Col>

            <Col xs={12} xl={7}>
              <div className="px-5 px-lg-6 pt-4 pb-5 pb-lg-6">
                <div>
                  <h4 className="mb-3">Media Assets</h4>
                  <div className="mb-3">
                    {attachments.map((attachment, index) => (
                      <FileListItem
                        key={attachment.name}
                        attachment={attachment}
                        className={classNames({
                          'border-top': index === 0
                        })}
                      />
                    ))}
                  </div>
                  <div className="">
                    <Button
                      variant="link"
                      className="text-decoration-none p-0"
                      startIcon={
                        <FontAwesomeIcon icon={faPlus} className="me-1" />
                      }
                    >
                      Add asset(s)
                    </Button>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default BoardViewModal;
